import * as React from 'react';
type Props = {
  className?: string;
};
export function ThumbsUpFilled({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-thumbs-up-filled"
      className={className}
    >
      <path
        d="M8.00403 21H16.4C16.9626 21 17.51 20.8175 17.96 20.48C18.4101 20.1425 18.7386 19.6677 18.8961 19.1276L20.7601 12.7277C20.873 12.3403 20.8943 11.9319 20.8221 11.5349C20.7499 11.1378 20.5862 10.7629 20.344 10.44C20.1018 10.1171 19.7878 9.855 19.4268 9.67449C19.0657 9.49398 18.6676 9.4 18.264 9.4H14.8718L15.3709 7.34369L15.3713 7.34173C15.4974 6.82976 15.5064 6.29591 15.3974 5.77999C15.2884 5.26342 15.064 4.77816 14.741 4.36048C14.4181 3.9428 14.0049 3.60351 13.5324 3.36794C13.0599 3.13237 12.5403 3.00661 12.0124 3.00008C11.6294 2.99533 11.2773 3.20978 11.1058 3.55227L8.34585 9.06427L8.34448 9.067C8.29481 9.16696 8.21824 9.25109 8.12337 9.30992C8.08563 9.33332 8.04559 9.35235 8.00403 9.36678L8.00403 21Z"
        fill="currentColor"
      />
      <path
        d="M6.00403 9.4H5.60001C4.91045 9.4 4.24913 9.67393 3.76154 10.1615C3.27394 10.6491 3.00001 11.3104 3.00001 12V18.4C3.00001 19.0896 3.27394 19.7509 3.76154 20.2385C4.24913 20.7261 4.91045 21 5.60001 21H6.00403L6.00403 9.4Z"
        fill="currentColor"
      />
    </svg>
  );
}
